'use client';

import * as DS from '@aurorasolar/ds';
import { x } from '@xstyled/styled-components';
import Link from 'next/link';

import { Category } from './fetchCategories';

export const CategoriesList = ({ categories }: { categories: Category[] }) => (
  <DS.Flex gap={2}>
    <x.h3 fontWeight={300}>Categories</x.h3>
    {categories?.map((category) => (
      <Link href={`/home-solar/blog/${category.slug}`} key={category.slug}>
        <DS.Text color="uiHelperCopy" fontWeight={500} text="body14">
          {category.name}
        </DS.Text>
      </Link>
    ))}
  </DS.Flex>
);
